const QcType = {
  compliance: 1,
  moc: 2,
  scenarioTag: 3,
}

const QcTypeMap = {
  [QcType.compliance]: '违规判断',
  [QcType.moc]: '能力评分',
  [QcType.scenarioTag]: '情景标签',
}

const ComplianceType = {
  violation: 0,
  exemption: 1,
}

const QcSchemeStatus = {
  pending: 0,
  optimizing: 1,
  optimized: 2,
}

const QcSchemeStatusMap = {
  [QcSchemeStatus.pending]: {
    text: '待调优',
    color: 'error',
  },
  [QcSchemeStatus.optimizing]: {
    text: '调优中',
    color: 'warning',
  },
  [QcSchemeStatus.optimized]: {
    text: '已调优',
    color: 'success',
  },
}

const DataType = {
  call: 0,
  wechat: 1,
}

const ActionMode = {
  offline: 1,
  online: 2,
}

const CurrentSteps = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
}

const StatusSteps = {
  STEP_ONE: 1,
  STEP_TWO: 2,
  STEP_THREE: 3,
}

const TaskStatus = {
  // 0：禁用 1：草稿-第一步 2：草稿-第二步 3：开启
  STOP: 0,
  STEP_ONE: 1,
  STEP_TWO: 2,
  RUNNING: 3,
}

export {
  QcType,
  QcTypeMap,
  ComplianceType,
  QcSchemeStatus,
  QcSchemeStatusMap,
  DataType,
  ActionMode,
  CurrentSteps,
  StatusSteps,
  TaskStatus,
}
